<template>
  <TableLayout :permissions="['renthouse:rhphoneexchangerecord:query']">
    <!-- 搜索表单 -->
    <el-form
      ref="searchForm"
      slot="search-form"
      :model="searchForm"
      label-width="100px"
      inline
    >
      <el-form-item label="获取者" prop="userId">
        <el-select
          v-model="searchForm.userId"
          filterable
          remote
          clearable
          reserve-keyword
          placeholder="请输入手机号查询"
          :remote-method="getUserList"
          :loading="loadingUser"
          @change="search"
        >
          <el-option
            v-for="item in userOptions"
            :key="item.id"
            :label="item.username + (item.mobile ? `(${item.mobile})` : '')"
            :value="item.id"
          >
            <div style="display: flex; align-items: center">
              <el-avatar
                shape="circle"
                :size="30"
                fit="cover"
                :src="imgUrl + item.avatar"
              ></el-avatar>
              <div style="padding-left: 10px">
                <span>{{ item.username }}</span>
                <span
                  v-if="item.mobile"
                  style="color: #8492a6; font-size: 12px; margin-left: 5px"
                  >{{ item.mobile }}</span
                >
              </div>
            </div>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="目标用户" prop="targetUserId">
        <el-select
          v-model="searchForm.targetUserId"
          filterable
          remote
          clearable
          reserve-keyword
          placeholder="请输入手机号查询"
          :remote-method="getTargetUserList"
          :loading="loadingTargetUser"
          @change="search"
        >
          <el-option
            v-for="item in targetUserOptions"
            :key="item.id"
            :label="item.username + (item.mobile ? `(${item.mobile})` : '')"
            :value="item.id"
          >
            <div style="display: flex; align-items: center">
              <el-avatar
                shape="circle"
                :size="30"
                fit="cover"
                :src="imgUrl + item.avatar"
              ></el-avatar>
              <div style="padding-left: 10px">
                <span>{{ item.username }}</span>
                <span
                  v-if="item.mobile"
                  style="color: #8492a6; font-size: 12px; margin-left: 5px"
                  >{{ item.mobile }}</span
                >
              </div>
            </div>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否房东" prop="isLandlord">
        <el-select
          v-model="searchForm.isLandlord"
          placeholder="请选择"
          @change="search"
        >
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始时间" prop="startTime">
        <el-date-picker
          v-model="searchForm.startTime"
          type="datetime"
          placeholder="选择日期时间"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间" prop="endTime">
        <el-date-picker
          v-model="searchForm.endTime"
          type="datetime"
          placeholder="选择日期时间"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>

    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        border
        :row-class-name="getRowClassName"
      >
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column label="获取者" min-width="150">
          <template slot-scope="{ row }">
            <div>{{ row.userNickName || row.userId }}</div>
            <div v-if="row.userMobile" style="color: #909399; font-size: 12px">
              {{ row.userMobile }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="目标用户" min-width="150">
          <template slot-scope="{ row }">
            <div>{{ row.targetNickName || row.targetUserId }}</div>
            <div
              v-if="row.targetMobile"
              style="color: #909399; font-size: 12px"
            >
              {{ row.targetMobile }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="房源" min-width="200">
          <template slot-scope="{ row }">
            <div>ID: {{ row.houseId }}</div>
            <div v-if="row.houseTitle">{{ row.houseTitle }}</div>
            <div v-if="row.housePhone">电话: {{ row.housePhone }}</div>
          </template>
        </el-table-column>
        <el-table-column label="兑换类型" width="100">
          <template slot-scope="{ row }">
            <el-tag v-if="row.exchangeType === 0" type="success">免费</el-tag>
            <el-tag v-else-if="row.exchangeType === 1" type="warning"
              >付费</el-tag
            >
            <span v-else>{{ row.exchangeType }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否房东" width="100">
          <template slot-scope="{ row }">
            <el-tag v-if="row.isLandlord === 1" type="success">是</el-tag>
            <el-tag v-else type="info">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="160"
        ></el-table-column>

        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="deleteById(row)"
              v-permissions="['renthouse:rhphoneexchangerecord:delete']"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import { fetchList as fetchUserList } from '@/api/system/user'

export default {
  name: 'RhPhoneExchangeRecord',
  extends: BaseTable,
  components: { TableLayout, Pagination },
  data () {
    return {
      searchForm: {
        userId: '',
        targetUserId: '',
        isLandlord: '',
        startTime: '',
        endTime: ''
      },
      userOptions: [],
      targetUserOptions: [],
      loadingUser: false,
      loadingTargetUser: false,
      imgUrl: process.env.VUE_APP_API_IMG
    }
  },
  created () {
    this.config({
      module: '手机号查询记录',
      api: '/rentHouse/rhPhoneExchangeRecord',
      'field.id': 'id',
      sorts: [
        {
          property: 'CREATE_TIME',
          direction: 'DESC'
        }
      ]
    })
    this.search()
    this.getUserList('')
    this.getTargetUserList('')
  },
  methods: {
    getRowClassName ({ row, rowIndex }) {
      return ''
    },
    async getUserList (query) {
      this.loadingUser = true
      try {
        const params = {
          page: 1,
          capacity: 20,
          model: {},
          sorts: []
        }
        if (query) {
          params.model.mobile = query
        }
        const res = await fetchUserList(params)
        this.userOptions = res.records
      } finally {
        this.loadingUser = false
      }
    },
    async getTargetUserList (query) {
      this.loadingTargetUser = true
      try {
        const params = {
          page: 1,
          capacity: 20,
          model: {},
          sorts: []
        }
        if (query) {
          params.model.mobile = query
        }
        const res = await fetchUserList(params)
        this.targetUserOptions = res.records
      } finally {
        this.loadingTargetUser = false
      }
    }
  }
}
</script>
